import React from 'react';
import IconButton from '@mui/material/IconButton';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import Drawer from '@mui/material/Drawer';
import Box from '@mui/material/Box';
import CloseIcon from '@mui/icons-material/Close';
import MetadataApliableFilterCard from './MetadataApliableFilterCard'; 

/** MyMine Version2.0 新規追加
 * FilterMenu
 */

export const FilterMenu = ({ isPc, isOpenFilterMenu, openFilterMenu, closeFilterMenu, controlSettings, content, setApliableFilterList, checkedList, setCheckedList }) => {

    return (
      <>
        <IconButton
          color="inherit"
          className='p-0'
          onMouseEnter={openFilterMenu}
        >
          <FilterAltIcon sx={{ fontSize: '35px', position: 'relative', right: '-20%' }} />
        </IconButton>
        <Drawer sx={{ '& .MuiDrawer-paper': { maxHeight: '800px', top: 30 } }} anchor="left" open={isOpenFilterMenu} onClose={closeFilterMenu}>
          <Box>
            <IconButton onClick={closeFilterMenu} style={{ position: 'absolute', right: 0, top: 0 }}>
              <CloseIcon sx={{ fontSize: '30px' }} />
            </IconButton>
            <MetadataApliableFilterCard
              cardTitle={controlSettings.LabelList.lblFilterResultTitle}
              metadataList={content}
              controlSettings={controlSettings}
              setApliableFilterList={setApliableFilterList}
              checkedList={checkedList}
              setCheckedList={setCheckedList}
            />
          </Box>
        </Drawer>
      </>
    );
};

export default FilterMenu;
